import { render } from "./vue3-progressbar.vue?vue&type=template&id=55c63237"
import script from "./vue3-progressbar.vue?vue&type=script&lang=js"
export * from "./vue3-progressbar.vue?vue&type=script&lang=js"
script.render = render

export default script